const variables = {
    colors: {
        darkBlue: '#00041d',
        lightBlue: '#000b50'
    }
}

export {variables};